import { CommonService } from "../../../../../services/CommonService";
import RemoteWork from "../../components/RemortWork";
import { order } from "../SmartSearchParammeter";

export default async function TypeOfWorkSearchConfig(key) {
  let typeWork = await CommonService.getRemoteWorkOptions();
  return {
    description: "Remote Work",
    id: "remoteWorkId",
    initial: [],
    type: order.second,
    handleValues: (searchObject) => {
      return;
    },
    Component: (searchObject, setSearchObject, onChange, t) => (
      <div className="col-6 mt-2">
        <RemoteWork searchObject={searchObject} onChange={onChange} t={t} />
      </div>
    ),
    handleValues: (searchObject) => {
      return;
    },
    operation: ["Must"],
    list: typeWork.map((t) => t.description.replace(/,/g, "#")),
    examples: [
      `Natural Language: "I want a developer that works remotely\nStructured Query: " ${key} Must Remote"`
    ],
    handler: function (searchObj, value) {
      searchObj["remoteWorkId"] = typeWork
        .filter((t) => value[0] == t.description.replace(/#/g, ",").trim())
        .map((t) => t.id)
        .shift();
    }
  };
}
